import React, { useEffect, useContext } from "react"

import SEO from "../components/seo"
import Tracking from "../components/tracking"
import Layout from "../components/layout"
import { Intro } from "../components/Intro"

import { CaseBuilder } from "../components/CaseBuilder"
import PressMarquee from "../components/PressMarquee"
import { About } from "../components/About"
import Reviews from "../components/Reviews"

// import { Context } from "../context/MainContext"

// import { getLocalStorage, isBrowser } from "../util"

const persistedEmailId = "marco_email_capture"

const IndexPage = () => {
  // const { toggleEmailModal } = useContext(Context)

  // useEffect(() => {
  //   const initialize = () => {
  //     const isEmailModalExpired = () => {
  //       if (isBrowser) {
  //         const timestamp = getLocalStorage(persistedEmailId)
  //         if (timestamp === null) return true
  //         const timeStampDate = new Date(timestamp)
  //         const oneDay = timeStampDate.setHours(timeStampDate.getHours() + 24)
  //         return new Date(timestamp) > new Date(oneDay)
  //       }
  //       return false
  //     }

  //     if (isEmailModalExpired()) {
  //       toggleEmailModal()
  //     }
  //   }
  //   const timeout = setTimeout(() => {
  //     initialize()
  //     clearTimeout(timeout)
  //   }, 1500)
  // }, []) // eslint-disable-line

  return (
    <Layout>
      <Tracking />
      <SEO title="Home" />
      <PressMarquee />
      <Intro />
      <CaseBuilder />
      <About />
      <Reviews />
    </Layout>
  )
}

export default IndexPage
